import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import Link from '@mui/material/Link';
import Day from './Day.js';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

class Screen extends React.Component {

	constructor()	{
		super();
		this.state = {
			varmonth : new Date().getMonth(),
			varyear : new Date().getFullYear(),
			notes : []
		}
	}

	// Functions to get the current date 
	getCYear() {return new Date().getFullYear();}
	getCMonth() {return new Date().getMonth();}
	getCDay() {return new Date().getDate();}

	// Is the year a leap year ?
	isLeap(year) {
	  if (year % 4 === 0) {
	    if (year % 100 === 0){
	      if (year % 400 === 0){
	        return 1;
	      } else {return 0;}
	    } else {return 1;}
	  } else{return 0;}
	}

	// Return February's days
	isLeapMonth(month,year,DataMonths) {
		if (month===1) {
			if (this.isLeap(year)===1) {
				return DataMonths[month][1]+1
			}	else {return DataMonths[month][1]}
		}	else {return DataMonths[month][1]}
	}

	// Return the number of days of the month(count leap years)
	Month(month,year) {
		const DataMonths = [["January",31],["February",28],["March",31],["April",30],["May",31],["June",30],["July",31],["August",31],["September",30],["October",31],["November",30],["December",31]];
		// const DataMonths = [["Janvier",31],["Fevrier",28],["Mars",31],["Avril",30],["Mai",31],["Juin",30],["Juillet",31],["Aout",31],["Septembre",30],["Octobre",31],["Novembre",30],["Decembre",31]];
		const Days = [DataMonths[month][0],this.isLeapMonth(month,year,DataMonths)]
		return Days
	}

	// Made to add a blue border for the current date
	isDay(month,year,day) {
		if (month===this.getCMonth()) {
			if (year===this.getCYear()) {
				if (day===this.getCDay()) {
					return {borderColor:"#2196f3",boxShadow:5};
				} else {return {boxShadow:2}}
			}	else {return {boxShadow:2}}
		} else {return {boxShadow:2}}
	}

	handleNote = (notesArr) => { this.setState({notes: notesArr}); }

	// Build cards for each days of the month
	GDays() {
		const GridDays = [];
		for (var i=1;i<this.Month(this.state.varmonth,this.state.varyear)[1]+1;i++) {
			GridDays.push(
				<Day key={i} data={{day:i,month:this.state.varmonth,year:this.state.varyear}} onAddNote={this.handleNote} Notes={this.state.notes} />
			);
		}
		return (
			<Grid container spacing={2}>
				{GridDays}
      		</Grid>
		)
	}

	// Button to change month
	previousMonth() {
		if (this.state.varmonth===0){
			this.setState({varmonth:11,varyear:this.state.varyear-1})
		} else {this.setState({varmonth:this.state.varmonth-1})}
	}

	nextMonth() {
		if (this.state.varmonth===11){
			this.setState({varmonth:0,varyear:this.state.varyear+1})
		} else {this.setState({varmonth:this.state.varmonth+1})}
	}

	render(){
		return(
			<>
      			<LinearProgress variant="determinate" value={this.state.varmonth*100/11}/>
				<Stack direction="row" spacing={1} sx={{m:2}} >
					<Typography sx={{fontSize:28,width:100,textAlign:"center"}}> {this.state.varyear} </Typography>
					<IconButton aria-label="previous" onClick={()=>{this.previousMonth();}}> <ArrowBackIosNewIcon /> </IconButton>
	      			<Typography sx={{fontSize:28,width:180,textAlign:"center"}}> {this.Month(this.state.varmonth,this.state.varyear)[0]} </Typography>
	      			<IconButton aria-label="next" onClick={()=>{this.nextMonth();}}> <ArrowForwardIosIcon/> </IconButton>
				</Stack>
				<Box sx={{ m:2 }}>
					{this.GDays()}
				</Box>
				<Typography sx={{fontSize:14, m:1, position:"fixed", bottom:0}}> Made by <Link href="http://mikgamer.fr" sx={{textDecoration:"none"}}>Michael Perard</Link> </Typography>
			</>
		);
	}


}

export default Screen;